(function() {
    "use strict";

    const ko = require('knockout');
    const $ = require('jquery');
    const koFileUpload = require('../components/ko.fileUpload');

    class EditCharacterViewModel {
        constructor(data) {
            this.id = data.id;
            this.owner = data.owner;
            this.name = ko.observable(data.name || '');
            this.avatar = ko.observable(data.avatar || null);
            this.physical = ko.observable(data.physical || '');
        }

        load() {
        }

        save() {
            let hasAvatar = false;

            try { // Check if the avatar is a valid Base64 encoded string (which means a new one has been uploaded)
                atob(this.avatar().split(',').splice(1, 1)[0]);
                hasAvatar = true;
            } catch(e) {}
            if (!this.avatar()) hasAvatar = true;

            const args = {
                name: this.name(),
                physical: this.physical()
            };

            if (hasAvatar) {
                args.avatar = this.avatar();
            }

            if (this.id) {
                args.id = this.id;
                $.ajax('/api/character/' + this.id, {
                    method: 'put',
                    data: args,
                    success: data => {
                        if (data.success) {
                            window.location.href = '/profile/' + this.owner.id + '/character/' + this.id;
                        }
                    }
                });
            } else {
                $.ajax('/api/character', {
                    method: 'post',
                    data: args,
                    success: data => {
                        if (data.success) {
                            window.location.href = '/profile/' + this.owner.id + '/character/' + data.id;
                        }
                    }
                });
            }
        }
    }

    module.exports = EditCharacterViewModel;
})();


// WEBPACK FOOTER //
// ./resources/scripts/viewmodels/editCharacterViewModel.js